export const getScrollableParentUtil = (node) => {
    if (!node)
        return null;
    try {
        const { overflowY } = window.getComputedStyle(node);
        const isScrollable = overflowY !== "visible" && overflowY !== "hidden";
        if (isScrollable && node.scrollHeight > node.clientHeight) {
            return node;
        }
    }
    catch (error) {
        console.error("Error accessing computed styles:", error);
        return null;
    }
    return getScrollableParentUtil(node.parentElement);
};
export default getScrollableParentUtil;
